import { render } from "./postitus2.vue?vue&type=template&id=163bc840&scoped=true"
const script = {}

import "./postitus2.vue?vue&type=style&index=0&id=163bc840&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163bc840"]])

export default __exports__